<template>
  <div id="app">
    <AppLayout>
      <router-view />
    </AppLayout>
    <AppNotification />
  </div>
</template>
<script>
import AppNotification from "@/layouts/components/AppNotification";
export default {
  components: { AppNotification },
};
</script>
